import MojitoPresentation from 'mojito/presentation';

import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import {eventPageFactory} from './event-page.factory';

import PALETTE_SCHEMA from './event-page.palette-schema.yaml';
import SCHEMA from './event-page.schema.yaml';

const NavigationPathBuilder = MojitoPresentation.Base.Navigation.NavigationPathBuilder;

class EventPageFeature extends AbstractVisualFeature {
    get name() {
        return 'EventPage';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        const {prebuiltBetsPosition, priceBoostedMarketsPosition} = this.config;

        return mergeTo(eventPageFactory(PALETTE), {
            EventMarkets: {
                prebuiltBetsPosition,
                priceBoostedMarketsPosition,
            },
        });
    }

    updateViewsConfig(viewsConfig) {
        mergeTo(viewsConfig, {
            EventPage: {
                homePageIntent: {
                    type: MojitoPresentation.Base.Intent.Types.VIEW,
                    data: NavigationPathBuilder.toHome(),
                },
                eventEndRedirectIntent: {
                    type: MojitoPresentation.Base.Intent.Types.VIEW,
                    data: NavigationPathBuilder.toInplay(),
                },
                redirectDelayAfterEventEnded: GENBET_BASED ? 30000 : 35000,
            },
        });

        super.updateViewsConfig(viewsConfig);
    }
}

export const EventPage = new EventPageFeature(SportsContent);
